<a (click)="btnClicked()">
    {{ text }} <i class="fa {{ icon }}"></i>
</a>